import { render } from "./GameLobby.vue?vue&type=template&id=66446e1b&ts=true"
import script from "./GameLobby.vue?vue&type=script&lang=ts"
export * from "./GameLobby.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alejandromillan/Documents/Projects/wrwlf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__